import http from "../http-common";

class TicketService {

    getListTicketMasterSchool(nameTicket, page, limit) {
        return http.get(`/ticket/getListTicket?nameTicket=${nameTicket}&pageNumber=${page}&maxPageItem=${limit}`)
    }

    createTicketMasterSchool(data) {
        return http.post(`/ticket/create-update`, data);
    }

    getDetailTicketMasterSchool(id) {
        return http.get(`/ticket/${id}`);
    }

    deleteTicketMasterSchool(id) {
        return http.delete(`/ticket/${id}`)
    }

    deleteMultiTicketMasterSchool(idTicketList) {
        return http.delete(`/ticket/deleteManyTicket?idTicketList=${idTicketList}`);
    }

    setDefaultTicketMasterSchool(id) {
        return http.get(`/ticket/setDefaultTicKet?idTicket=${id}`);
    }
}

export default new TicketService();